const API_URL = '/api';

export default {
  GET_POSTS: `${API_URL}/posts`,
  GET_ACCOUNT: `${API_URL}/account`,
};

export const SENTRY_CONFIG = {
  SENTRY_DSN: 'https://fa48d21856844facac045a4f3c704141@o1045882.ingest.sentry.io/4504530734809088',
};

export const PACKAGE = {
  NAME: process.env.PACKAGE_NAME,
  VERSION: process.env.VERSION,
  ENVIRONMENT: process.env.ENVIRONMENT || 'local',
};
